<template>
  <v-layout>
    <v-flex class="my-4 ma-3" xs4 v-html="displayName"/>
    <v-flex xs6 class="ma-3">
      <v-select
        :items="remindTemplatesList"
        item-text="templateKey"
        item-value="id"
        :value="emailTemplate"
        @input="changeTemplateKey"
        label="Choose Email Template"
        :disabled="!isWriteAvailable"
      ></v-select>
    </v-flex>
    <v-flex xs7 class="ma-3">
      <v-textarea
        name="CommentText"
        label="Text to comment"
        :value="commentText"
        rows="2"
        v-model="commentText"
      >
        {{ commentText }}
      </v-textarea>
    </v-flex>
    <v-flex xs2 class="ma-3">
      <v-btn v-if="emailTemplate" @click="resetTemplate()">Reset</v-btn>
      <v-btn v-else="emailTemplate" disabled>Reset</v-btn>
    </v-flex>

    <v-flex xs2 class="ma-3">
      <v-btn @click="changeTemplateKey(emailTemplate)">Save</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import mixins from '@/utils/mixins'
  export default {
    name: 'email-select',
    mixins: [mixins.isWriteAvailable, mixins.emailTemplates],
    props: {
      displayName: {
        type: String
      },
      registrationStatus: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write',
        commentText: ''
      }
    },
    computed: {
      ...mapGetters([
        'attendeeReminders',
        'emailTemplatesKeyAndId'
      ]),
      emailTemplate () {
        if (this.attendeeReminders) {
          const currentStatus =  this.attendeeReminders.find(val => val.registrationStatus === this.registrationStatus)
          return currentStatus ? currentStatus.emailTemplateId : ''
        }
      },

    },
    methods: {
      ...mapActions([
        'editAttendeeReminders',
        'resetEmailTemplate'
      ]),
      changeTemplateKey (val) {
        this.editAttendeeReminders({ registrationStatus: this.registrationStatus, emailTemplateId: val, commentText: this.commentText })
      },
      async getCommentText () {
        if (this.attendeeReminders) {
          const currentStatus =  this.attendeeReminders.find(val => val.registrationStatus === this.registrationStatus)
          this.commentText = currentStatus ? currentStatus.commentText : ''
        }
      },
      async resetTemplate () {
        await this.resetEmailTemplate(this.registrationStatus)
      }
    },
    beforeMount () {
      this.getCommentText()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Settings/AttendeeRegistrationRemind/emailSelect.vue